import * as React from 'react';
import {connect} from 'react-redux'
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";

import {Dialogs} from "./types";

import {findValueById} from '../Utils';

interface Props extends Dialogs {
    companyName: string
}

const Footer = (onHide: () => void) =>  (
    <div>
        <Button>
            <a href="/planner/"> Перейти в планировщик </a>
        </Button>
        <Button label="Закрыть" className={'p-button-secondary'} onClick={onHide} />
    </div>
)

const AppointmentRequestDialog = ({visible, onHide, companyName}: Props) => {
    return (
        <Dialog
            header='Назначение'
            className='custom-dialog'
            visible={visible}
            onHide={onHide}
            style={{maxWidth: '700px', width: '100%'}}
            footer={Footer(onHide)}
            closable={false}
            draggable={false}
        >
            <p>
                Вы подтвердили свой интерес к проекту <b>{companyName}</b> .
                Пожалуйста, перейдите в сервис планирования для назначения слотов
            </p>
        </Dialog>
    );
};


function mapStateToProps(state) {
    return { companyName: findValueById(state.forms.values, 'company_name')}
}
  
export default connect(mapStateToProps)(AppointmentRequestDialog)